import 'rxjs/add/operator/do';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor(public authService: AuthService, public router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do(event => { }, err => {
      if (err instanceof HttpErrorResponse && err.status == 401) {
        this.authService._logOut();
        //this.router.navigate(['/login']);
        let redirectUri = location.protocol + '//' + location.host + '/#/login'; // angular 1 login
        window.location.href = redirectUri;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/interceptors/response.interceptor.ts